import loadingImageQueue from '../loadingImageQueue'

export default {
  data() {
    return {
      imagePreviewLoaded: false,
    }
  },
  methods: {
    doLoadImagePreview(previewSize) {
      const preview = this.element?.file?.previews[previewSize]
      
      if (!preview) return

      console.log('adding image to loading queue', preview, loadingImageQueue)
      loadingImageQueue.add(() => {
        return new Promise((resolve) => {
          const image = new Image()
          image.onload = () => {
            resolve(this.imagePreviewLoaded = true)
          }

          image.onerror = () => {
            resolve()
            setTimeout(() => {
              if (this.doLoadImagePreview) {
                this.doLoadImagePreview(previewSize)
              }
            }, 1000)
          }

          image.src = preview
        })
      })
    },
  },
}
